function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("rect", {
  id: "avatar-3-a",
  width: 70,
  height: 70,
  rx: 24
}), React.createElement("linearGradient", {
  id: "avatar-3-c",
  x1: "50%",
  x2: "50%",
  y1: "0%",
  y2: "100%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#1D0024"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#100014"
})), React.createElement("linearGradient", {
  id: "avatar-3-d",
  x1: "50%",
  x2: "50%",
  y1: "0%",
  y2: "100%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#1D0024"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#100014"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("mask", {
  id: "avatar-3-b",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#avatar-3-a"
})), React.createElement("use", {
  fill: "#A0A6B8",
  opacity: 0.1,
  xlinkHref: "#avatar-3-a"
}), React.createElement("g", {
  mask: "url(#avatar-3-b)"
}, React.createElement("path", {
  d: "M3.5 7h63v63h-63z"
}), React.createElement("path", {
  fill: "url(#avatar-3-c)",
  fillRule: "nonzero",
  d: "M45.058 44.602c1.13 2.139 1.977 7.105 2.542 14.898H0c.565-7.793 1.412-12.759 2.542-14.898 1.694-3.21 8.78-6.876 21.258-11.002 12.478 4.126 19.564 7.793 21.258 11.002z",
  transform: "translate(11.2 10.5)"
}), React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M35.35 56.467c-.58 0-1.05-.418-1.05-.934 0-.515.47-.933 1.05-.933.58 0 1.05.418 1.05.933 0 .516-.47.934-1.05.934zm0 4.666c-.58 0-1.05-.418-1.05-.933 0-.515.47-.933 1.05-.933.58 0 1.05.418 1.05.933 0 .515-.47.933-1.05.933zm0 4.667c-.58 0-1.05-.418-1.05-.933 0-.516.47-.934 1.05-.934.58 0 1.05.418 1.05.934 0 .515-.47.933-1.05.933z"
}), React.createElement("path", {
  fill: "url(#avatar-3-d)",
  fillRule: "nonzero",
  d: "M41.644 30.8l-37.51-4.444c-1.849-9.623.345-15.687 6.58-18.19C13.599-1.094 24.819-.341 27.999.414 38.822 2.984 43.37 13.112 41.644 30.8z",
  transform: "translate(13.3 10.5)"
}), React.createElement("path", {
  fill: "#FFDBC9",
  d: "M29.06 47.385v-13.84c-5.856-.086-4.714-10.087 1.17-7.035 1.054.461 3.746-.807 2.81-3.921 6.32 4.613 15.126-3.484 15.682 1.499 1.094 9.806-1.023 17.865-6.638 17.866-.551 0-1.088.018-1.789-.105v5.536C38.463 48.462 36.63 49 34.797 49c-1.832 0-3.745-.538-5.737-1.615z"
}), React.createElement("path", {
  fill: "#FFBC9E",
  d: "M40.25 41.577V43.4c-3.6 0-6.4-1.633-8.4-4.9 2.4 1.52 5.2 2.545 8.4 3.077z"
}), React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M34.642 48.353c1.576-.077 5.534-.915 5.534-2.724V44.1c.423 0 1.632 1.025 2.254 1.893 2.458 3.43-.269 6.507-2.493 6.507-2.806 0-4.665-2.41-5.287-3.568-.622 1.159-2.481 3.568-5.287 3.568-2.224 0-4.951-3.076-2.493-6.507.622-.868 1.831-1.893 2.254-1.893v1.529c0 1.81 3.854 2.647 5.518 2.724z"
})));

var SvgAvatar4 = function SvgAvatar4(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAvatar4, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/avatar-4.fb74af1c.svg";
export { ForwardRef as ReactComponent };